<template>
  <el-form
    ref="form"
    id="formModel"
    v-bind="computedConfig"
    :rules="rules"
    :model="data"
    :label-width="labelWidth"
  >
    <el-row>
      <el-col
        v-for="(item, index) in computedItems"
        :key="getItemKey(item, index)"
        :md="item.md || 12"
        :sm="item.sm || 12"
      >
        <template v-if="!item.isShowCom">
          <el-form-item
            :label="item.label ? item.label + ':' : ''"
            :prop="item.prop"
            :class="item.class"
          >
            <!-- 使用插槽label -->
            <render-content
              slot="label"
              v-if="item.labelRender"
              :render="item.labelRender"
              :data="item"
            ></render-content>
            <slot :name="item.slot" v-bind="{ item }">
              <component
                v-if="item.component"
                :ref="item.ref || `cp-${item.prop}`"
                :is="item.component"
                :data="data"
                :modelData="item"
                :placeholder="item.props.placeholder || placeholder(item)"
                v-model="data[item.prop]"
                v-bind="item.props"
                v-on="item.listeners"
              >
                <render-content
                  v-if="item.contentRender"
                  :render="item.contentRender"
                  :data="item"
                ></render-content>
              </component>
              <span v-else>{{ data[item.prop] }}</span>
            </slot>
          </el-form-item>
        </template>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
const defaultConfig = {
  labelWidth: "auto",
};
// 表单字段格式化
const RenderContent = {
  props: {
    render: Function,
    formatter: Function, // 格式化数据
    data: Object,
    prop: String,
  },
  render(h) {
    if (this.render) {
      return this.render(h, this.data);
    }
    let value = this.data[this.prop];
    if (this.formatter) {
      value = this.formatter(value, this.data);
    }
    return <span>{value}</span>;
  },
};
// element UI 组件
const alias = {
  input: {
    component: "el-input",
    props: { clearable: true },
  },
  textarea: {
    component: "el-input",
    props: {
      type: "textarea",
      autosize: {
        minRows: 4,
        maxRows: 4,
      },
      clearable: true,
    },
  },

  label: {
    component: "render-content",
    props: {},
  },

  datePicker: {
    component: "el-date-picker",
    props: {
      style: {
        width: "100%",
      },
      "value-format": "yyyy-MM-dd",
      format: "yyyy-MM-dd",
      clearable: true,
    },
  },
  timePicker: {
    component: "el-time-picker",
    props: {
      style: {
        width: "100%",
      },
      "value-format": "HH:mm:ss",
      format: "HH:mm:ss",
      clearable: true,
    },
  },
  datetimerange: {
    component: "general-model",
    props: {
      type: "datetimerange",
    },
  },
  cascader: {
    component: "general-model",
    props: {
      type: "cascader",
      clearable: true,
    },
  },
  rate: {
    component: "general-model",
    props: {
      type: "rate",
    },
  },

  upload: {
    component: "general-model",
    props: {
      type: "upload",
    },
  },
  uploadPdf: {
    component: "general-model",
    props: {
      type: "uploadPdf",
    },
  },
  select: {
    component: "general-model",
    props: {
      type: "select",
      clearable: true,
    },
  },
  checkbox: {
    component: "general-model",
    props: {
      type: "checkbox",
    },
  },
  radio: {
    component: "general-model",
    props: {
      type: "radio",
    },
  },
  query: {
    component: "general-model",
    props: {
      type: "query",
      clearable: true,
    },
  },
  number: {
    component: "general-model",
    props: {
      type: "number",
    },
  },
};
export default {
  name: "FormModule",
  components: {
    RenderContent,
  },
  props: {
    formConfig: {
      type: Object,
      default: () => {
        return {
          labelWidth: "auto",
          labelPosition: "right",
        };
      },
    },
    labelWidth: {
      type: String,
      default: "160px",
    },
    formItems: Array,
    data: Object,
  },
  computed: {
    computedConfig() {
      return {
        ...this.formConfig,
      };
    },
    computedItems() {
      const itemResult = [];
      for (const item of this.formItems) {
        let { component, showIf, prop, props, ...theArgs } = item;
        if (
          (typeof showIf === "function" && !showIf(this.data)) ||
          (typeof showIf === "boolean" && showIf)
        ) {
          continue;
        }
        if (typeof props === "function") {
          props = props(this.data);
        }
        if (component === "label") {
          props = {
            ...props, 
            data: this.data, 
            prop, 
          };
        }
        if (alias[component]) {
          props = {
            ...alias[component].props,
            ...props,
          };
          component = alias[component].component; 
        }
        itemResult.push({
          component,
          prop,
          props,
          ...theArgs,
        });
      }
      return itemResult;
    },
    rules() {
      let rules = this.computedItems.reduce((total, item) => {
        var type = Object.prototype.toString
          .call(item.rules)
          .replace(/\[object\s|\]/g, "");
        if (item.rules) {
          let rules = item.rules;
          if (typeof rules === "function") {
            rules = rules(this.data);
          }
          total[item.prop] = rules;
        } else if (type != "Boolean") {
          let rules;
          switch (item.component) {
            case "el-input":
              rules = [
                {
                  required: true,
                  trigger: "blur",
                  message: `此为必填项，不能为空！`,
                },
              ];
              break;
            default:
              rules = [
                {
                  required: true,
                  trigger: "change",
                  message: `此为必填项，不能为空！`,
                },
              ];
              break;
          }
          total[item.prop] = rules;
        }
        return total;
      }, {});
      return rules;
    },
  },
  methods: {
    getItemKey(item, index) {
      return `${item.prop}-${index}`;
    },
    validate() {
      return new Promise((resolve) => {
        this.$refs.form.validate(resolve);
      });
    },
    clearValidate(props) {
      this.$refs.form.clearValidate(props);
    },
    resetFields() {
      this.$refs.form.resetFields();
    },
    placeholder(item) {
      switch (item.component) {
        case "el-input":
          return `请输入${item.label}`;
        default:
          return `请选择${item.label}`;
      }
    },
    directives() {
      return "asd";
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .formH .el-form-item__label {
  width: 120px !important;
  height: 40px !important;
  display: inline-block;
  line-height: inherit !important;
}
::v-deep .btn_list .el-form-item__content {
  margin-left: 20px !important;
}
::v-deep .el-rate {
  line-height: 2.5 !important;
}
</style>
